<template>
  <div class="spacey-12">
    <InviteTeammate
      is-project-modal
      :project-info="projectInfo"
      :placeholder="$t('Enter name, position or email to invite your teammate')"
      @update-members="updateMembers"
      @deny-access="handleDeleting"
    />
    <Spinner v-if="isLoading" />
    <div v-else :key="team.length" class="base-table spacey-12">
      <div class="table-header settings-users-table-columns">
        <div class="text-sm grey-500">
          {{ $t('Teammate') }}
        </div>
        <div class="text-sm grey-500">
          {{ $t('Position') }}
        </div>
        <div class="text-sm grey-500 vertical-centering spacex-4">
          <span>{{ $t('Role') }}</span>
          <RolesTooltip />
        </div>
        <div></div>
      </div>
      <ProjectTeammate
        v-for="member in team"
        :key="member.user.id"
        :member="{ ...member.user, role: member.role }"
        @delete="handleDeleting($event, member.user)"
      />
    </div>
  </div>
</template>

<script>
  import RolesTooltip from '@/components/common/Tooltips/RolesTooltip';
  import InviteTeammate from '@/containers/top-menu/header/tender/contractor/InviteTeammate';
  import Spinner from 'vue-simple-spinner';
  import ProjectTeammate from '@/containers/project/ProjectTeammate';
  import membersQuery from '@/gql/projects/members.graphql';
  import request from '@/utils/api/request';
  import { mapActions, mapState } from 'vuex';
  import parseError from '@/utils/formatting/parse-error';
  import TransferResponsibility from '@/containers/project/TransferResponsibility';
  import factory from '@/utils/api/factory';

  export default {
    name: 'ProjectTeammatesForm',
    components: {
      ProjectTeammate,
      InviteTeammate,
      RolesTooltip,
      Spinner,
    },
    data() {
      return {
        isLoading: false,
      };
    },
    apollo: {
      projectInfo() {
        return {
          query: membersQuery,
          variables() {
            return {
              id: this.$route.params.id,
            };
          },
          update(data) {
            if (data.projects?.[0]) return data.projects[0];
            return null;
          },
        };
      },
    },
    computed: {
      ...mapState('confirmModal', ['context']),
      team() {
        return this.projectInfo?.team || [];
      },
    },
    methods: {
      ...mapActions('alert', ['showAlert']),
      ...mapActions({
        openModal: 'modal/openModal',
        openConfirm: 'confirmModal/openModal',
      }),
      updateMembers() {
        this.$apollo.queries.projectInfo.refetch();
      },
      async denyAccess(id) {
        await request.post(`/projects/${this.projectInfo.id}/deny-access/`, {
          user_id: id,
        });
        this.updateMembers();
      },
      async handleDeleting(id, user) {
        try {
          await this.denyAccess(id);
        } catch (e) {
          if (e.response.status === 403) {
            this.openConfirm({
              title: this.$t('Transfer tender responsibility'),
              component: TransferResponsibility,
              actionText: this.$t('Set representative'),
              data: {
                tenders: e.response.data?.tenders || [],
                user,
                team: this.projectInfo.team,
              },
              action: async () => {
                let selectedId = this.context?.data?.selectedUser;
                let userId = this.context?.data?.user.id;
                if (selectedId && userId) {
                  try {
                    await factory(`projects/${this.projectInfo.id}`).postInPath(
                      'change_contact_person_for_tenders',
                      {
                        user_id: selectedId,
                        tender_ids: e.response.data?.tenders.map((tender) => tender.id),
                      }
                    );
                    await this.denyAccess(userId);
                  } catch (e) {
                    this.showAlert({
                      type: 'error',
                      text: parseError(e),
                    });
                    console.error(e);
                  }
                }
              },
            });
          } else {
            this.showAlert({
              type: 'error',
              text: parseError(e),
            });
            console.error(e);
          }
        }
      },
    },
  };
</script>
